import buildQuery from 'utils/filtros';

const INITIAL_STATE = {
  page: 1,
  data: [],
  links: {
    next: null,
    previous: null,
  },
  count: 0,
};

export const Types = {
  async: {
    LISTAR: 'vagas/listar_async',
    FILTRAR: 'vagas/filtrar_async',
  },
  sync: {
    LISTAR: 'vagas/listar',
    FILTRAR: 'vagas/filtrar_sync',
  },
};

// Actions Creators
export const Actions = {
  listarVagas: (page = 1) => ({ type: Types.async.LISTAR, payload: page }),
  filtarVagas: filtro => {
    const query = buildQuery(filtro);
    return { type: Types.async.FILTRAR, payload: query };
  },
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.sync.LISTAR:
      return { ...state, ...action.payload };
    case Types.sync.FILTRAR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
